/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */
/**
 * The class name added to a drop target.
 */
export const DROP_TARGET_CLASS = 'jp-mod-dropTarget';
/**
 * The class name added to a drop source.
 */
export const DROP_SOURCE_CLASS = 'jp-mod-dropSource';
//# sourceMappingURL=constants.js.map